import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import MapSection from "./components/MapSection";
import RankingSection from "./components/RankingSection";
import PlatformSection from "./components/PlatformSection";
import EventSection from "./components/EventSection";
import AboutSection from "./components/AboutSection";
import FaqSection from "./components/FaqSection";
import CtaSection from "./components/CtaSection";
import Footer from "./components/Footer";

export default function Home() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <Navbar />
      <main className="flex-1">
        <Hero />
        <MapSection />
        <RankingSection />
        <PlatformSection />
        <EventSection />
        <AboutSection />
        <CtaSection />
        <FaqSection />
      </main>
      <Footer />

      <a
        href="#top"
        aria-label="返回顶部"
        className={`fixed bottom-6 right-6 z-50 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lift transition-all duration-300 hover:bg-primary-600 ${showTop ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-4 opacity-0"}`}
      >
        <i className="ri-arrow-up-line text-xl" aria-hidden="true"></i>
      </a>
    </div>
  );
}